<template>
    <div class="modal" ref="assignedUsersAndCompaniesModal" id="assignedUsersAndCompaniesModal" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">

                <div class="modal-header bg-white font-bold">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Assign User and Company</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="w-full">
                        <div class="flex flex-row">
                            <div class="flex w-full justify-center items-center font-semibold text-grey-darkest">
                                User
                            </div>
                            <div class="flex w-full justify-center items-center">
                                <multiselect :options="users"
                                    v-model="form.user"
                                    placeholder="Select..."
                                    :show-labels="false"
                                    track-by="id" label="name" class="my-2 mr-2 cursor-pointer">
                                </multiselect>
                            </div>
                        </div>
                    </div>

                    <div class="w-full">
                        <div class="flex flex-row">
                            <div class="flex w-full justify-center items-center font-semibold text-grey-darkest">
                                Company
                            </div>
                            <div class="flex w-full justify-center items-center">
                                <multiselect :options="companies"
                                    v-model="form.company"
                                    placeholder="Select..."
                                    :show-labels="false"
                                    track-by="id" label="name" class="my-2 mr-2 cursor-pointer">
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary assign-user-btn" @click.prevent="massUpdate()">
                        Assign <i v-if="loadingUpdate" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";

export default {
    name: 'assigned-users-contact',
    props: {
        checked_contact_ids: { type: Array }
    },
    components: { Multiselect },

    data() {
        return {
            loadingUpdate: false,
            users: [],
            companies: [],
            form: new Form({
                contact_ids: [],
                user: null,
                company: null,
            })
        }
    },

    mounted() {
        $("#assignedUsersAndCompaniesModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            this.form.contact_ids = [ ...this.checked_contact_ids ];
            axios.get(route('api.contact.mass-update.get-users-and-companies'))
                .then( ({data}) => {
                    this.users = data.users;
                    this.companies = data.companies;
                })
                .catch( (err) => {
                    console.error(err);
                });
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.users = [];
            this.form.contact_ids = [];
            this.form.user = null;
            this.form.company = null;
        },

        massUpdate() {
            this.loadingUpdate = true;
            let titleString = this.form.contact_ids.length == 1 ? this.form.contact_ids.length+' contact is selected, are you sure you want to update it?' : this.form.contact_ids.length+' contacts are selected, are you sure you want to update them?';
            let textString = this.form.contact_ids.length == 1 ? 'Record' : 'Records';
            Swal.fire({
                title: titleString,
                text: textString+" can't be undo once updated.",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    this.form.put('/api/contact/mass-update/assigned-user-and-company')
                        .then( (data) => {
                            this.loadingUpdate = false;
                            this.close();
                            this.$emit('update-finished', data);
                        })
                        .catch( (err) => {
                            this.loadingUpdate = false;
                            console.error(err);
                        });
                }
            });

        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .assign-user-btn {
        border-radius: 25px !important;
    }
</style>
